var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.product.selling_plan_groups &&
    _vm.product.selling_plan_groups.length > 0
    ? _c("div", { staticClass: "product-sub-tile" }, [
        _c(
          "a",
          {
            staticClass: "product-tile__image-wrapper",
            attrs: { href: _vm.product.url },
          },
          [
            _c("img", {
              directives: [
                {
                  name: "lazy",
                  rawName: "v-lazy",
                  value: _vm.image.src,
                  expression: "image.src",
                },
              ],
              staticClass: "product-tile__image",
              attrs: { alt: _vm.image.alt },
            }),
            _c("img", {
              directives: [
                {
                  name: "lazy",
                  rawName: "v-lazy",
                  value: _vm.altImage.src,
                  expression: "altImage.src",
                },
              ],
              staticClass: "product-tile__image--hover",
              attrs: { alt: _vm.altImage.alt },
            }),
            _vm.isBestSeller
              ? _c("div", { staticClass: "product-tile__badge preheader" }, [
                  _vm._v("Best Seller"),
                ])
              : _vm._e(),
            _vm.isNewProduct
              ? _c("div", { staticClass: "product-tile__badge preheader" }, [
                  _vm._v("New Product"),
                ])
              : _vm._e(),
            _vm.isNewProductRoast
              ? _c("div", { staticClass: "product-tile__badge preheader" }, [
                  _vm._v("New Roast"),
                ])
              : _vm._e(),
          ]
        ),
        _c(
          "div",
          { staticClass: "product-sub-tile__content", class: _vm.tileClasses },
          [
            _c(
              "a",
              { attrs: { href: _vm.product.url } },
              [
                _c("product-bottom-line", {
                  attrs: {
                    "product-id": _vm.product.id,
                    "display-no-reviews": false,
                  },
                }),
                _c("h3", { staticClass: "product-sub-tile__title" }, [
                  _vm._v(_vm._s(_vm.cleanedTitle)),
                ]),
                _c("p", { staticClass: "product-tile__price" }, [
                  _c("span", { staticClass: "product-tile__price--original" }, [
                    _vm._v(_vm._s(_vm._f("money")(_vm.originalPrice))),
                  ]),
                  _c(
                    "span",
                    { staticClass: "product-tile__price--discounted" },
                    [_vm._v(_vm._s(_vm._f("money")(_vm.selectedPrice)))]
                  ),
                  _c(
                    "span",
                    { staticClass: "product-tile__price--discount-percent" },
                    [_vm._v(_vm._s(_vm.savingsText))]
                  ),
                ]),
                _c("product-roast", { attrs: { level: _vm.getRoastLevel } }),
              ],
              1
            ),
            _vm.displayForm
              ? _c("product-form", {
                  attrs: {
                    product: _vm.product,
                    "default-to-subscription": true,
                  },
                  on: { productVariantPrice: _vm.setSelectedVariantPrice },
                })
              : _c("primary-button", {
                  staticClass: "start-subscription",
                  attrs: { secondary: "", label: "Get Started" },
                  on: { click: _vm.toggleForm },
                }),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }